import React from 'react';
import C18Select00 from './C18Select00'
import C18Anchor00 from './C18Anchor00'
import C18Select01 from './C18Select01'
import C18Input00 from './C18Input00'
import C18Button00 from './C18Button00'
import C18SubMenuHeader00 from './C18SubMenuHeader00'
// import C18SiteZoneView00 from './C18SiteZoneView00'
import {wsTrans,doGetPostBasic} from '../utils/utils'
import {loadSitesInfo,loadZonesInfo,loadSummaryPresetsInfo,loadUsersInfo,getSiteName,getZoneName,getUserIndex,getSummaryPresetIndex,loadPrivsInfo,privs} from './C18utils'
import {cl,globs,constant,dateToDisplayDate, addNumbering,
  getTime,
  getRandomString,az,ocf,trimStr} from '../../components/utils/utils';
import LoadingSpinner from './loadingSpinner'

class C18DevPage00 extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      loaded: false,
      dueDate:"2025-04-03",
      startDate:"2025-04-03",
      compDate:"2025-04-03",
      estSP:13,
      curSP:8,
      todSP:1,
      remSP:0,
      selIssue:-1,
      curDemo:"cur",
      demoDate:"2025-02-01",
      pageType:"issues",
      firstMonth:663,
// //       tasks:[
// //         {
// //           id:"1234",
// //           name:"task1",
// //           color:"#CCDDEE",
// //           days:3,
// //           start:"2025-05-03",
// //           end:"2025-05-08",
// //           due:"2025-06-01"
// //         }
//
//       ]

    }
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveInfo)
    this.setBreadCrumbs()
    this.loadInfo()
    this.dayMs=86400*1000
//     this.colors=[
//       "#AAAAEE",
//       "#AABBEE",
//       "#AACCEE",
//       "#AADDEE",
// //       "#AAEEEE",
//       "#AAEEDD",
//       "#AAEECC",
//       "#AAEEBB",
//       "#AAEEAA",
//       "#BBEEAA",
//       "#CCEEAA",
//       "#DDEEAA",
//       "#EEEEAA",
//       "#EEDDAA",
//       "#EECCAA",
//       "#EEBBAA",
//       "#EEAAAA",
//       "#EEAABB",
//       "#EEAACC",
//       "#EEAADD",
//       "#EEAAEE",
//       "#DDAAEE",
//       "#CCAAEE",
//       "#BBAAEE",
//     ]
    this.colors=[
"#E0B7B7",
"#E0BFB7",
"#E0C6B7",
"#E0CEB7",
"#E0D6B7",
"#E0DDB7",
"#DBE0B7",
"#D3E0B7",
"#CCE0B7",
"#C4E0B7",
"#BCE0B7",
"#B7E0BA",
"#B7E0C1",
"#B7E0C9",
"#B7E0D1",
"#B7E0D8",
"#B7E0E0",
"#B7D8E0",
"#B7D1E0",
"#B7C9E0",
"#B7C1E0",
"#B7BAE0",
"#BCB7E0",
"#C4B7E0",
"#CBB7E0",
"#D3B7E0",
"#DBB7E0",
"#E0B7DD",
"#E0B7D6",
"#E0B7CE",
"#E0B7C6",
"#E0B7BF"
// "#F5A3BF",
// "#F6A2BE",
// "#FDE19B",
// "#FFF599",
// "#FFE799",
// "#FFE699",
// "#FFD699",
// "#FFB199",
// "#CEE6B2",
// "#CEE5B3",
// "#B8E0BA",
// "#B7E1DD",
// "#9DDDFB",
// "#9DDEFB",
// "#9FD1F9",
// "#9ED1FA",
// "#B5BCE3",
// "#B6BDE2",
// "#C5B4E4",
// "#DDB4E4",
// "#F6A2BE",
// "#FFB199",
// "#D4C8C4",
// "#CCCCCC",
// "#C4CFD4",
//       "#F8BBD0",// Pastel Pink
//       "#F48FB1",// Rose Pink
//       "#F06292",// Watermelon Pink
//       "#FBC02D",// Pastel Gold
//       "#FFF176",// Butter Yellow
//       "#FFD54F",// Apricot
//       "#FFECB3",// Light Peach
//       "#FFE0B2",// Pastel Orange
//       "#FFCCBC",// Coral Peach
//       "#DCEDC8",// Light Lime
//       "#C5E1A5",// Soft Green
//       "#AED581",// Pastel Olive
//       "#81C784",// Mint Green
//       "#80CBC4",// Aqua Mint
//       "#4DB6AC",// Seafoam
//       "#B2DFDB",// Pale Teal
//       "#B3E5FC",// Sky Blue
//       "#81D4FA",// Baby Blue
//       "#4FC3F7",// Robin’s Egg Blue
//       "#64B5F6",// Powder Blue
//       "#90CAF9",// Cloud Blue
//       "#9FA8DA",// Lavender Blue
//       "#7986CB",// Pastel Indigo
//       "#B39DDB",// Light Lavender
//       "#9575CD",// Orchid
//       "#CE93D8",// Lilac
//       "#F48FB1",// Pastel Rose
//       "#FFAB91",// Salmon
//       "#A1887F",// Soft Taupe
//       "#E0E0E0",// Light Grey
//       "#B0BEC5",// Pale Slate
//       "#CFD8DC",// Soft Silver
    ]
    this.curColor=0
  }

  componentWillUnmount=()=>{
    cl("component will unmount")
    this.subscribe_savePageEvent.remove()
  }

  setBreadCrumbs=()=>{
    if(this.props.parms){
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:"DevPage", url:`/usa/c18/admin/devPage`},
            ]},
        },
      )
    }
  }

  getParents=(issues)=>{
    let parents={}
    issues.forEach(iss=>{
      let par=iss.fields.parent?.key//||iss.key
      if(par){parents[par]=1}
    })
    cl(parents)
    let color=0
    Object.keys(parents).forEach(k=>{
      parents[k]={color:this.colors[color]}
      color=(color+7)%32
    })
    this.parColors=parents
    cl(parents)
  }

  loadIssues=async(user,curDemo)=>{
    let st=this.state
    let query={cmd:(curDemo=="cur")?
      "currentSprintIssues":"demoSprintIssues"}
//       cl(query)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/jira",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query})
    cl(res)
    let sprints={}
//     cl(res)
    res.data.issues.forEach(i=>{
//       cl(i.key)
      let sp=i.fields.customfield_10001
//       cl(sp)
//       let arr=sp.filter(s=>{
//         return s.state=="active"
//       })
//       .forEach(a=>{
//         sprints[a.id]=a.name
//       })
//       cl(sp)
//       cl(arr)
    })
//     cl(sprints)
//     cl(res.data.issues)
    let issues=res.data.issues.filter(iss=>{
//       cl(iss)
      return (iss.fields.assignee?.accountId||"")==user.jiraAccountId
    })
    this.getParents(issues)
    return[issues,sprints]
  }

//   loadDbIssues=async()=>{
//     let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/devIssues",
//       method: "retrieve", sessionId: globs.userData.session.sessionId,
//       body: {}})
//     cl(res)
//   }

//   saveDbIssues=async()=>{
//     let st=this.state
//     st.issues[0].lastView=getTime()
//     cl(st.issues)
//     let query={issues:st.issues}
//     let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/devIssues",
//       method: "update", sessionId: globs.userData.session.sessionId,
//       body: query})
//   }

  sortIssues=(issues,issArr)=>{
    let keyVal={}
    issues.forEach(iss=>{
      iss.days=this.spToDays(iss.fields.customfield_10006)
      iss.workTime=[[0,0]]
      keyVal[+iss.key.split("-")[1]]=iss})
//     cl(issArr)
    issArr.forEach((iss,i)=>{
      let val=keyVal[iss.key]
      if(val){
        if(iss.days){val.days=iss.days}
        if(iss.workTime){val.workTime=iss.workTime}
        if(!i){val.lastView=iss.lastView}
        val.index=i+1
      }
    })
    issues=issues.sort((a,b)=>{
      if((a.index||1e6)<(b.index||1e6)){return -1}
      if((a.index||1e6)>(b.index||1e6)){return 1}
      return 0
    })
//     cl(issues)
    return issues
//     return issArr.map((iss,i)=>{
//       let val=keyVal[iss.key]
//       if(iss.days){val.days=iss.days}
//       val.workTime=iss.workTime
//       if(!i){val.lastView=iss.lastView}
//       return val})
  }

  loadInfo=async()=>{
    let st=this.state
    let user=globs.usersInfo.info.filter(u=>{
      return u.userId==globs.userData.session.userId
    })[0]
    let [issues,sprints]=await this.loadIssues(user,st.curDemo)
    issues=this.sortIssues(issues,user.issues)
    if(!issues[0].lastView){issues[0].lastView=this.getToday()}
    cl(issues)
//     cl(globs)
    this.setState({issues:issues,user:user,sprints:sprints,loaded:true,
      tasks:globs.user.tasks||[],
    })
//     cl(res)

  }

  onChange=async(type,vals)=>{
    cl(type,vals)
    let st=this.state
    var issues,sprints
    switch(type){
      case "selIssue":
        cl(st.issues[vals.selIssue])
        this.setState(vals)
        break
      case "jira":
        let key=st.issues[st.selIssue].key
        window.open(`https://link4corp.atlassian.net/browse/${key}`)
        break;
      case "remSP":
        this.setState(vals)
        break
      case "notes":
        issues=st.issues.slice(0)
        Object.assign(issues[st.selIssue],vals)
        this.setState({issues:issues})
        break
      case "save":
        this.saveChanges()
        break
      case "curdemo":
        [issues,sprints]=await this.loadIssues(st.user,vals.curDemo)
        this.setState({issues:issues,sprints:sprints,
          curDemo:vals.curDemo})
        break
      case "taskDate":
        globs.events.publish("savePageEnable",true)
        let [id,field]=vals.key.split("-")
        let tasks=st.tasks.splice(0)
        let task=tasks.filter(t=>{return t.id==id})[0]
        task[field]=vals.val
        this.setState({tasks:tasks})
        break
      case "taskDays":

        break
      case "taskMod":
        globs.events.publish("savePageEnable",true)
        this.taskMods(vals)
        break
      case "taskName":
      case "taskDesc":
        globs.events.publish("savePageEnable",true)
        return this.taskName(vals)
        break
      case "selTask":
        if(vals.selTask==st.selTask){vals.selTask=null}// fall through
      default:
        this.setState(vals)
    }
  }

  saveChanges=async()=>{
    let st=this.state
    cl("save changes")
    cl(st.issues[st.selIssue])
    let issue=st.issues[st.selIssue].key
    let query={cmd:"createIssue",issue:issue,sp:+st.remSP}
    cl(query)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/jira",
      method: "create", sessionId: globs.userData.session.sessionId,
      body: query})
  }

  showIssue=()=>{
    let st=this.state
    if(st.selIssue<0){return}
    let issue=st.issues[st.selIssue]
    let sprint=issue.fields.customfield_10001.filter(s=>{
      return s.state=="active"
    }).map(s=>{return s.name})
    let cell={fontSize:22,height:36}
    return(
      <div><br/><br/>
      <h2>{issue.fields.summary}</h2>
      <table style={{width:"initial"}}><tbody>
      <tr><td>
        <table style={{width:"initial",fontSize:36}}><tbody>
        <tr><td style={cell}>Due Date</td>
        <td style={cell}>{st.dueDate}</td></tr>
        <tr><td style={cell}>Start Date</td>
        <td style={cell}>{st.startDate}</td></tr>
        <tr><td style={cell}>Completion Date</td>
        <td style={cell}>{st.compDate}</td></tr>
        <tr><td style={cell}>Priority</td>
        <td style={cell}>{issue.fields.priority.name}</td></tr>
        <tr><td style={cell}>Sprint</td>
        <td style={cell}>{sprint}</td></tr>
        <tr><td style={cell}>Status</td>
        <td style={cell}>{issue.fields.status.name}</td></tr>
        <tr><td style={cell}>Estimated SP</td>
        <td style={cell}>{st.estSP}</td></tr>
        <tr><td style={cell}>Current SP</td>
        <td style={cell}>{st.curSP}</td></tr>
        <tr><td style={cell}>Todays SP</td><td>
          <input type="text" style={{width:100,fontSize:22}}
            value={st.todSP}
            onChange={e=>this.onChange("todSP",{todSP:e.target.value})
          }/>
        </td></tr>
        <tr><td style={cell}>Remaining SP</td><td>
        <input type="text" style={{width:100,fontSize:22}}
          value={st.remSP}
          onChange={e=>this.onChange("remSP",{remSP:e.target.value})
        }/>
        </td></tr>
        </tbody></table>
      </td><td style={{width:20}}>
      </td><td valign="top">
      <label style={{fontSize:18}}>Notes</label>
      <textarea style={{resize:"none"}} cols="40" rows="10"
        value={st.issues[st.selIssue].notes||""}
        onChange={e=>{this.onChange("notes",{notes:e.target.value})}}
      />
      </td></tr>
      </tbody></table><br/>
              <C18Button00 type="button" className="filled"
        onClick={e=>{this.onChange("jira")}}
      >Jira</C18Button00>&nbsp;
      <C18Button00 type="button" className="filled"
        onClick={e=>{this.onChange("save")}}
      >Save</C18Button00><br/>

      </div>
    )
  }

  showIssuesO=()=>{
    let st=this.state
//     cl(st)
    let cell={fontSize:22}
    let issueLines=st.issues.map((iss,i)=>{
      let status=iss.fields.status.name
      let key=iss.key.split("-")[1]
      let bgColor=(st.selIssue==i)?"#C0E0FF":"white"
      return(
        <tr key={i} style={{cursor:"pointer",backgroundColor:bgColor}}
          onClick={e=>{this.onChange("selIssue",{selIssue:i})}}
        >
        <td style={cell}>{key}&nbsp;</td>
        <td style={cell}>{status}&nbsp;</td>
        <td style={cell}>{iss.fields.summary}</td>
        </tr>
      )
    })
    return(
      <div>
      <table style={{width:"initial"}}><tbody>
        {issueLines}
      </tbody></table>
      </div>
    )
  }

  doUpIssue=(key,move)=>{
    let st=this.state
    let keys=st.issues.map(is=>{return is.key.split("-")[1]})
    let pos=keys.indexOf(key)
    if(!pos){return}// at top
    let issues=st.issues.slice(0)

    let issue=issues.splice(pos,1)[0]// the one that we're moving
    if(move==0){pos=1}// to top
    if(pos==1){// we're changing #1
      cl("change 1")
      let now=getTime()
      issue.workTime.push([now,0])// new #1
      let wt=issues[0].workTime// old #1
      cl(wt)
      wt[wt.length-1][1]=now
    }
    issues.splice(pos-1,0,issue)
    cl(issues)
    this.setState({issues:issues})
  }

  upIssue=(e,val)=>{
    globs.events.publish("savePageEnable",true)
    if(this.upIssueTO){// double click
      clearTimeout(this.upIssueTO)
      this.upIssueTO=null
      this.doUpIssue(val,0)
    }else{
      this.upIssueTO=setTimeout(e=>{
        this.doUpIssue(val,-1)
        this.upIssueTO=null
      },500)
    }
//     cl(val)
  }

  statusAbbrev={"Open Jira":"open","In Progress":"work",
    "Under Review":"revw","Rejected":"RJCT","Ready for Testing":"test",
    "Done":"done"
  }

  setIssueValue=(val,key,field)=>{
    let st=this.state
    let issues=st.issues.slice(0)
    let issue=issues.filter(iss=>{return iss.key.split("-")[1]==key})[0]
    issue[field]=val
    cl(issue)
    this.setState({issues:issues})
  }

  setDays=(e,key)=>{
    cl(e.target.value,key)
    globs.events.publish("savePageEnable",true)
    this.setIssueValue(e.target.value,key,"days")
  }

  spToDays=(sp)=>{
    sp-=2
    if(sp<0){sp=0}
    return 2**sp
  }

  getToday=()=>{return Math.floor(getTime()/86400)}
  getKey=(key0)=>{return key0.split("-")[1]}

  showIssues=()=>{
    let st=this.state
//     cl(st)
    let cell={fontSize:16}
//     cl(st.issues)
// onClick={e=>{this.onChange("selIssue",{selIssue:i})}}
    let expTS=+new Date()
    let issueLines=st.issues.map((iss,i)=>{
      let status=this.statusAbbrev[iss.fields.status.name]
      let key=iss.key.split("-")[1]
      let cvp=iss.fields.customfield_10645
//       let expDate="here"
      let dueDate=(iss.fields.duedate||"").slice(-5)
      let days=iss.days
//       if(!days){days=this.spToDays(iss.fields.customfield_10006)}
//         let storyPoints=iss.fields.customfield_10006-2
//         if(storyPoints<0){storyPoints=0}
//         days=2**storyPoints
//       }
      var done
      if(["test","done"].includes(status)){
        let wt=iss.workTime
        let le=wt.at(-1)
//         cl(le)
        if(!le[1]){
          le[1]=getTime()
        }
        done=le[1]*1000
      }else{
        expTS+=days*86400*1000
        done=expTS
      }
      let expDate=dateToDisplayDate(new Date(done),"mm-dd")
      let summ=trimStr(iss.fields.summary,90)
      let bgColor=(st.selIssue==i)?"#C0E0FF":null
      bgColor=
        iss.fields.labels.includes("CustomerIssues")?"#CCCC88":bgColor
      let parId=iss.fields.parent?.key||iss.key
      let parColor=this.parColors[parId]?.color
      cl(parColor,iss.key,parId)
      let isParent=Object.keys(this.parColors).includes(iss.key)
      let daysD=(i)?
        (days):
        <input
        value={days}
        onChange={ocf(this.setDays,key)}
        style={{width:25,border:"1px solid #CCCCCC"}}
        />
      return(
        <tr key={i}

        >
        <td
        onClick={ocf(this.upIssue,key)}
        style={{cursor:"pointer"}}
        >^</td>
        <td style={cell}
        >{cvp}&nbsp;</td>
        <td style={cell}>{daysD}&nbsp;</td>
        <td style={cell}>{expDate}&nbsp;</td>
        <td style={cell}>{dueDate}&nbsp;</td>
        <td style={cell}>
        <a href={`https://link4corp.atlassian.net/browse/C20C22-${key}`}
        style={{color:"#4488CC",backgroundColor:parColor,
          fontWeight:(isParent)?800:100,
          border:`${(isParent)?1:0}px solid #444444`
        }}
        target="_blank">{key}</a>
        &nbsp;</td>
        <td style={cell}>{status}&nbsp;</td>
        <td style={{backgroundColor:bgColor}}>{summ}</td>
        </tr>
      )
    })
    return(
      <div>
      <table style={{width:"initial"}}><tbody>
      <tr>
      <th>Mv</th>
      <th>CVP</th>
      <th>Days</th>
      <th>Done</th>
      <th>Due</th>
      <th>ID</th>
      <th>Status</th>
      <th>Summary</th>
      </tr>
        {issueLines}
      </tbody></table>
      </div>
    )
  }

  showCustIssue=()=>{
    let st=this.state
    return(
      <div>
      </div>
    )
  }

  showDateSel=()=>{
    let st=this.state
    cl("show date")
    return(
        <input type="date" style={{display:"inline-block"}}
          value={st.demoDate}
          onChange={e=>this.onChange("demoDate",
            {demoDate:e.target.value})}
        />
    )
  }

  showCurDemo=()=>{
    let st=this.state
//     cl(st.curDemo)
    return(
      <div>
        <input type="radio" name="CurDemo" id="cur" value="cur"
          style={{display:"inline-block"}}
          defaultChecked
          onChange={e=>this.onChange("curdemo",{curDemo:e.currentTarget.value})}
        />
        <label style={{display:"inline-block"}} htmlFor="cur">Current</label>&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="CurDemo" id="demo" value="demo"
          style={{display:"inline-block"}}
          onChange={e=>this.onChange("curdemo",{curDemo:e.currentTarget.value})}
        />
        <label style={{display:"inline-block"}} htmlFor="demo">Demo</label>&nbsp;&nbsp;&nbsp;&nbsp;
        {(st.curDemo=="demo")&&this.showDateSel()}
      </div>
    )
  }

  getTaskPos=(id)=>{
    let st=this.state
    return st.tasks.map(t=>{return t.id}).indexOf(id)
  }

  taskMods=(vals)=>{
    let st=this.state
    let pos=this.getTaskPos(vals.id)
    let tasks=st.tasks.slice(0)
    switch(vals.mod){
      case "+":
        let da=new Date()
        let today=`${da.getFullYear()}-${az(1+da.getMonth(),2)}-${az(da.getDate(),2)}`
        let newTask={
          id:getRandomString(8),
          name:"New Task",
          color:this.colors[this.curColor],
          days:1,
          start:today,
          end:today,
          due:today,
        }
        this.curColor=(this.curColor+5)%23
        tasks.splice(pos,0,newTask)
        break
      case "x":
        tasks.splice(pos,1)
        break
      case "^":
        if(pos>0){
          let task=tasks.splice(pos,1)[0]
          tasks.splice(pos-1,0,task)
        }
        break
      case "v":
        if(pos<tasks.length-1){
          let task=tasks.splice(pos,1)[0]
          tasks.splice(pos+1,0,task)
        }
        cl(tasks)
        break
    }
    this.setState({tasks:tasks})

  }

  addColors=(mo,yr,days)=>{
//     cl(mo,yr)
    let st=this.state
//     cl(days)
    st.tasks.forEach(t=>{
      let [y,m,d]=t.start.split("-")
      let start=new Date(y,m-1,d).getTime()
//       cl(start)
      let end=start+t.days*this.dayMs
//       cl(start,end)
      days.forEach(d=>{
        if(d){
//           cl(yr,mo,d.d)
          let da=new Date(yr,mo,d.d).getTime()
          if((da>=start)&&(da<end)){
//             cl(da)
            d.c=t.color
          }
//           cl(da)
        }
      })
//       cl(t)
//       cl(days)
    })
  }

  showMonth=(month,ranges)=>{
    let months=["January","February","March","April","May","June","July",
      "August","September","October","November","December"]
//     let dayMs=86400*1000
    let yr=Math.floor(1970+month/12)
    let mo=month%12
    let da=new Date(yr,mo,1).getTime()
    let da2=new Date(yr,mo+1,1).getTime()
    let dayDates=new Array(35)
    let d0=da-(new Date(da)).getDay()*this.dayMs
    for(let d=da;d<da2;d+=this.dayMs){dayDates[(d-d0)/this.dayMs]={d:((d-da)/this.dayMs)+1}}
    let rows=[]
    this.addColors(mo,yr,dayDates)
//     cl(dayDates)
    for(let w=0;w<5;w++){
      let days=[]
      for(let d=0;d<7;d++){
        let dInfo=dayDates[7*w+d]
        let bg=dInfo?.c
        days.push(<td style={{backgroundColor:bg}}
        key={7*w+d}>{dInfo?.d||""}</td>)
      }
      rows.push(<tr key={w}>{days}</tr>)
    }
    return(
      <table style={{width:"initial"}}><tbody>
      <tr><td align="center" colSpan="7">{months[mo]}</td></tr>
      <tr><th>S</th><th>M</th><th>T</th><th>W</th><th>T</th><th>F</th><th>S</th>
      </tr>
      {rows}
      </tbody></table>
    )
  }

  showMonths=()=>{
    let months=[]
    let st=this.state
    for(let i=0;i<5;i++){
      months.push(
        <td>{this.showMonth(st.firstMonth+i)}</td>
      )
    }
    return(
      <div>
      <table><tbody>
      <tr>{months}</tr>
      </tbody></table>
      </div>
    )

  }

  updateIssueLastView=()=>{
    let st=this.state
    let issues=st.issues.slice(0)
    let day1=issues[0].lastView
    let day2=this.getToday()
    if(day2!=day1){
      issues[0].days-=day2-day1
      issues[0].lastView=day2
      this.setState({issues:issues})
    }
  }

  saveInfo=async()=>{
    cl("save info")
    let st=this.state
    cl(globs)
    let issues=st.issues.map(iss=>{return({
      key:+iss.key.split("-")[1],
      days:iss.days,
      workTime:iss.workTime,
    })})
    issues[0].lastView=st.issues[0].lastView
    this.updateIssueLastView(issues)
    let query={
      userId:globs.user.userId,
      tasks:st.tasks,
      issues:issues,
    }
    cl(query)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/users",
      method: "update", sessionId: globs.userData.session.sessionId,
      body: query})
    globs.events.publish("saveOK",true)
//     globs.events.publish("savePageEnable",false)
  }

  showTaskDays=(task)=>{
    let st=this.state
    let key=`${task.id}-days`
    return(
      <td><input type="text" size="1"
        style={{padding:"initial",marginRight:10,marginLeft:10,
          height:"initial",borderRadius:"initial",
          border:"1px solid #CCCCCC"
        }}
        value={task.days}
        onChange={e=>{this.onChange("taskDate",{key:key,val:e.target.value})}}
      /></td>
    )
  }

  showTaskDate=(task,field)=>{
    let st=this.state
    let key=`${task.id}-${field}`
//     let sel=st.taskDateSel==key
    return(
      <td><input type="date"
        style={{padding:"initial",marginRight:10,marginLeft:10,
          height:"initial",borderRadius:"initial",
          border:"1px solid #CCCCCC"
        }}
        value={task[field]}
        onChange={e=>{this.onChange("taskDate",{key:key,val:e.target.value})}}
      /></td>
    )
//     if(sel){
//       return(
//         <td><input type="date"
//           style={{padding:"initial",height:"initial",borderRadius:"initial",
//             border:"1px solid #CCCCCC"
//           }}
//           value={task[field]}
//           onChange={e=>{this.onChange("taskDate",{key:key,val:e.target.value})}}
//         /></td>
//       )
//     }else{
//       return(
//         <td style={{cursor:"pointer"}}
//           onClick={e=>{this.onChange("setState",{taskDateSel:key})}}
//         >
//         <div style={{height:21,width:131,border:"1px solid #CCCCCC"}}>
//         {task[field]}
//         </div>
//         </td>
//       )
//     }
  }

  showTaskMod=(t,mod)=>{
    return(
      <td style={{cursor:"pointer"}}
        onClick={e=>{this.onChange("taskMod",{id:t.id,mod:mod})}}
      >
      {mod}
      </td>
    )
  }

  taskName=(vals)=>{
    let st=this.state
    let tasks=st.tasks.slice(0)
    let task=tasks.filter(t=>{return t.id==st.selTask})[0]
    Object.assign(task,vals)
    this.setState({tasks:tasks})
  }

  showSelTask=()=>{
    let st=this.state
    let task=st.tasks.filter(t=>{return t.id==st.selTask})[0]
//     cl(task)
    return(
      <tr key="selTask"><td colSpan="10">
        <div>
        <label>Task Name</label>
        <input type="text"
        value={task.name}
        onChange={e=>{this.onChange("taskName",{name:e.target.value})}}
        /><br/>
        <label>Description</label>
        <textarea rows="4" cols="50"
        value={task.desc||""}
        onChange={e=>{this.onChange("taskName",{desc:e.target.value})}}
        /><br/>
        </div>
      </td></tr>
    )
  }

  showTasks=()=>{
    let st=this.state
//     cl(st.tasks)
    let rows=st.tasks.map((t,i)=>{
      let [yr,mo,dy]=t.start.split("-")
      let da=new Date(yr,mo-1,dy).getTime()
      let end=new Date(da+this.dayMs*(t.days-1))
      let endDay=`${end.getFullYear()}-${az(1+end.getMonth(),2)}-\
${az(end.getDate(),2)}`
//       cl(end)
//       cl(da)
//       cl(yr,mo,da)
//       let da=new Date(t.start)
      return(
        <React.Fragment key={i}>
        <tr>
        {this.showTaskMod(t,"+")}
        {this.showTaskMod(t,"x")}
        {this.showTaskMod(t,"^")}
        {this.showTaskMod(t,"v")}
        <td style={{cursor:"pointer"}}
        onClick={e=>{this.onChange("selTask",{selTask:t.id})}}
        >{t.name}</td>
        <td style={{width:10,backgroundColor:t.color}}></td>
        {this.showTaskDays(t)}
        {this.showTaskDate(t,"start")}
        <td>{endDay}</td>
        {this.showTaskDate(t,"due")}
        </tr>
        {(t.id==st.selTask)&&this.showSelTask()}
        </React.Fragment>
      )
    })
    return(
      <div>
      <h3>Tasks</h3>
      <div style={{height:10}}/>
      <table style={{width:"initial"}}><tbody>
      <tr><th>Add</th><th>Del</th><th colSpan="2">Move</th><th>Name</th><th></th><th>Days</th>
      <th>Start</th><th>End</th><th>Due</th></tr>
      {rows}
      </tbody></table>
      <div style={{height:10}}/>
      </div>
    )
  }

  showSchedulePage=()=>{
    return(
      <div>
      {this.showMonths()}
      {this.showTasks()}
      </div>
    )
  }

  showIssuePage=()=>{
//       {this.showCurDemo()}
    return(
      <div>
      <h3>Active Issues</h3>
      {this.showIssues()}
      </div>
    )
//       {this.showCustIssue()}
//       {this.showIssue()}
  }

  showDevPage=()=>{
    let st=this.state
    let pages={issues:this.showIssuePage,schedule:this.showSchedulePage}
    return(
      <div>
      {pages[st.pageType]()}
      </div>
    )
//       {this.showIssuePage()}
  }

  render(){
    let st=this.state
    if(this.state.loaded){
//           <C18SubMenuHeader00 parms={{
//             items:[
//               {v:"issues",t:"Issues"},
//               {v:"schedule",t:"Schedule"},
//             ],
//             pageType: this.state.pageType,
//             onChange: o=>this.onChange("pageMenu",o),
//           }}/>
//           <div className="clearfloat"></div>
      return(
        <div>
          {this.showDevPage()}
        </div>
      )
    }else{
      return <LoadingSpinner message="loading page..." />
    }
  }
}

export default C18DevPage00;
